<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Car Loan Setting</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Loan</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-lg-12 mx-auto">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between">
                    <h4 class="card-title mb-0">Car loan settings
                    </h4>
                    <div class="col-auto float-right ml-auto">
                      <a class="btn add-btn ml-1" @click="openDialog"
                        ><i class="fa fa-plus"></i>New Setting</a
                      >
                      <a class="btn add-btn" @click="openDialogImport"
                        ><i class="fa fa-plus"></i>Import Setting</a
                      >
                    </div>
                  </div>
                </div>

                <!-- <div class="card-body">
                  <div class="table-responsive">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <table class="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th>Rank</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="rank in ranks" v-bind:key="rank.id">
                          <td>{{ rank.rankName }}</td>
                          <td>
                            <div class="view-icons">
                              <a
                                @click="setEditRank(rank)"
                                class="btn btn-link active"
                                data-toggle="modal"
                                data-target="#edit_rank"
                              >
                                <i class="fa fa-pencil m-r-5"></i>
                              </a>
                              <a
                                class="btn btn-link active"
                                @click="setDeleteRank(rank)"
                                data-toggle="modal"
                                data-target="#delete_rank"
                              >
                                <i class="fa fa-trash-o m-r-5"></i>
                              </a>
                            </div>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div> -->
              </div>
              <!-- Search Filter -->
              <div class="row filter-row">
                <div class="col-sm-6 col-md-6">
                  <div class="form-group form-focus">
                    <input
                      type="text"
                      class="form-control floating"
                      v-model="filterRank"
                      style="height: 55px !important"
                    />
                    <label class="focus-label">Search Rank</label>
                  </div>
                </div>
              </div>
              <!-- /Search Filter -->

              <v-data-table
                :headers="headers"
                :items="searchRank"
                :loading="loading"
                loading-text="Loading... Please wait"
                sort-by=""
                class="elevation-1 table"
              >
                <template v-slot:[`item.rank.rankName`]="{ item }">
                  {{ item.rank && item.rank.rankName }}
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ item.amount }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <!-- <div class="dropdown dropdown-action">
                  <a
                    href="#"
                    class="action-icon dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    ><i class="material-icons">more_vert</i></a
                  >
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item"
                      @click="setLeaveStatus(item)"
                      v-if="item.status == 0"
                      ><i class="fa fa-pencil m-r-5"></i> Approve or Reject</a
                    >
                  </div>
                </div> -->

                  <div class="view-icons">
                    <a
                      @click="setEditRank(item)"
                      class="btn btn-link active"
                      data-toggle="modal"
                      data-target="#edit_rank"
                    >
                      <i class="fa fa-pencil m-r-5"></i>
                    </a>
                    <a
                      class="btn btn-link active"
                      @click="setDeleteRank(item)"
                      data-toggle="modal"
                      data-target="#delete_rank"
                    >
                      <i class="fa fa-trash-o m-r-5"></i>
                    </a>
                  </div>
                </template>
              </v-data-table>
            </div>

            <!-- /Page Content -->
            <!-- Add Employee Modal -->
            <v-dialog v-model="dialog" max-width="725px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Add Setting</h5>
                  <button type="button" class="close" @click="close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form @submit.prevent="onSubmit">
                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="alert alert-danger alert-dismissible fade show"
                          role="alert"
                          v-if="error"
                        >
                          <strong>Error!</strong> {{ error }}
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="alert alert-success alert-dismissible fade show"
                          role="alert"
                          v-if="message"
                        >
                          <strong>Success!</strong> {{ message }}
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                    <div class="form-group">
                      <label>Level <span class="text-danger">*</span></label>

                      <select
                        class="form-control"
                        v-model.trim="$v.rankId.$model"
                      >
                        <option>Select Level</option>
                        <option
                          v-for="item in ranks"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.rankName }}
                        </option>
                      </select>
                    </div>
                  </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Amount <span class="text-danger">*</span></label
                          >
                          <input
                            class="form-control"
                            type="number"
                            v-model.trim="$v.amount.$model"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section">
                      <button
                        class="btn btn-primary submit-btn"
                        :disabled="submitted"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </v-dialog>
            <!-- /Add Employee Modal -->

            <!-- Edit Employee Modal -->
            <v-dialog v-model="dialogEdit" max-width="725px" v-if="setting">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Edit Setting</h5>
                  <button type="button" class="close" @click="closeEdit">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form>
                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="alert alert-danger alert-dismissible fade show"
                          role="alert"
                          v-if="error"
                        >
                          <strong>Error!</strong> {{ error }}
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="alert alert-success alert-dismissible fade show"
                          role="alert"
                          v-if="message"
                        >
                          <strong>Success!</strong> {{ message }}
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                    <div class="form-group">
                      <label>Level <span class="text-danger">*</span></label>

                      <select
                        class="form-control"
                        v-model="setting.rankId"
                      >
                        <option>Select Level</option>
                        <option
                          v-for="item in ranks"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.rankName }}
                        </option>
                      </select>
                    </div>
                  </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="col-form-label"
                            >Amount <span class="text-danger">*</span></label
                          >
                          <input
                            class="form-control"
                            type="number"
                            v-model="setting.amount"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section">
                      <button
                        @click.prevent="updateRank"
                        class="btn btn-primary submit-btn"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </v-dialog>
            <!-- /Edit Employee Modal -->

            <!-- Delete Employee Modal -->
            <v-dialog v-model="dialogDelete" max-width="725px">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="form-header">
                    <button type="button" class="close" @click="closeDelete">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h3>Delete Setting</h3>
                    <p>Are you sure want to delete?</p>
                  </div>
                  <div class="modal-btn delete-action">
                    <div class="row">
                      <div class="col-6">
                        <a
                          class="btn btn-primary continue-btn"
                          @click.prevent="removeRank"
                          data-dismiss="modal"
                          >Delete</a
                        >
                      </div>
                      <div class="col-6">
                        <a
                          @click="closeDelete"
                          data-dismiss="modal"
                          class="btn btn-primary cancel-btn"
                          >Cancel</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-dialog>
            <!-- /Delete Employee Modal -->
            <!-- Delete Employee Modal -->
            <v-dialog v-model="dialogImport" max-width="725px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Import Setting</h5>
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="closeImport"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-header">
                    <h3>Import Setting</h3>
                    <p>
                      Download an excel template by clicking on the below button
                    </p>
                    <br />
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <p>
                        Note: please do not change the layout of the cells in
                        the excel, you are expected to add your data below the
                        column header (first row). <br />
                        Regards <strong>Rank No</strong> column you are
                        expected to get the value from their representing sheet.
                        <br />
                      </p>
                    </div>
                    <div class="col-12">
                      <a
                        @click="downloadTemplate"
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                      >
                        Download Template</a
                      >
                    </div>
                  </div>
                  <hr />
                  <hr />
                  <div class="row">
                    <div class="col-sm-9">
                      <div class="form-group">
                        <label>Upload File</label>
                        <div class="custom-file">
                          <input
                            type="file"
                            name="file"
                            class="form-control"
                            id="cv_upload"
                            @change="onFilePicked"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <a
                        @click="importRank"
                        v-if="file"
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                      >
                        Import</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </v-dialog>
            <!-- /Delete Employee Modal -->
          </div>
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { organizationService } from "@/services/organizationService";
import { required } from "vuelidate/lib/validators";
import { authenticationService } from "@/services/authenticationService";
import Vue from "vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  mounted() {
    this.getRanks();
    this.getSettings()
  },
  data() {
    return {
      headers: [
        // {
        //   text: "Name",
        //   value: "profile"
        // },
        { text: "Rank", value: "rank.rankName" },
        { text: "Amount", value: "amount" },
        { text: "", value: "actions", sortable: false }
      ],

      filterRank: "",

      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      company: authenticationService.currentOfficeValue,
      rankId: "",
      setting: null,
      ranks: [],
      settings: [],
      loading: false,
      error: "",
      message: "",
      isCreateNewRank: false,
      submitted: false,
      file: null,
      fileName: ""
    };
  },

  validations: {
    rankId: { required },
    amount: { required }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },

  computed: {
    searchRank: function() {
      return this.settings.filter(d =>
        d.rank.rankName.toLowerCase().match(this.filterRank.toLowerCase())
      );
    }
  },

  methods: {
    getRanks() {
      organizationService.getRanks().then(o => {
        this.ranks = o;
      });
    },
    getSettings() {
      organizationService.getCarLoanSettings().then(o => {
        this.settings = o;
      });
    },
    // handleNewRank() {
    //   handleNewRank = !this.isCreateNewRank
    // },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    clearModel() {
      this.rankId = "";
      this.amount = null;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },
    openDialogImport() {
      this.dialogImport = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },

    setEditRank(model) {
      this.setting = model;
      this.dialogEdit = true;
    },

    setDeleteRank(model) {
      this.setting = model;
      this.dialogDelete = true;
    },

    removeRank() {
      const id = this.setting.id;
      organizationService.removeCarLoanSetting(id).then(
        id => {
          organizationService.getCarLoanSettings().then(l => {
            this.settings = l;
            this.dialogDelete = false;
          });
        },
        e => {
          this.error = "Car Loan Setting is being used in some information";
          this.dialogDelete = false;
        }
      );
    },
    downloadTemplate() {
      organizationService.downloadCarLoanSettingTemplate().then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    importRank() {
      organizationService.importCarLoanSetting(this.file, this.company.id).then(
        response => {
          organizationService.getCarLoanSettings().then(o => {
            (this.settings = o),
              // console.log(o),
              this.closeImport();
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    updateRank() {
      this.submitted = true;
      this.loading = true;
      organizationService
        .updateCarLoanSetting(
          this.setting
        )
        .then(
          id => {
            this.message = "Setting updated successfully";
            organizationService.getCarLoanSettings().then(w => {
              this.settings = w;
              this.dialogEdit = false;
            });
          },
          error => {
            this.error = error;
          }
        );
    },

    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      organizationService
        .addCarLoanSetting(
          this.company.id,
          this.rankId,
          this.amount
        )
        .then(
          id => {
            this.message = "Setting created successfully";
            organizationService.getCarLoanSettings().then(o => {
              this.settings = o;
              this.close();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    }
  },
  name: "ranks"
};
</script>



// WEBPACK FOOTER //
// src/components/miscs/carloansetting.vue